import logo from './logo.png';
import React,{ useState } from 'react';
import { useParams } from "react-router";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
const Forgotpassword =  () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    let { id } = useParams();
    const getemail = queryParams.get('email');
    const [email, setEmail] = useState('');
    const [npass, setNpass] = useState('');
    const [rpass, setRpass] = useState('');
    const [passworderr2, setPassworderr2] = useState('');
    const [emailerr, setEmailerr] = useState('');
    const [successmsg, setSuccessmsg] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [loader, setLoader] = useState(<div style={{paddingTop:'200px'}}> <center><Spinner animation="grow" variant="primary" />
        <Spinner animation="grow" variant="secondary" />
        <Spinner animation="grow" variant="success" />
        <Spinner animation="grow" variant="danger" />
        <Spinner animation="grow" variant="warning" />
        <Spinner animation="grow" variant="info" />
        <Spinner animation="grow" variant="light" />
        <Spinner animation="grow" variant="dark" /></center> </div>);    
    const handleSubmit = async(event) =>{
            setLoading(true);
            event.preventDefault();
            setEmailerr('');
            setSuccessmsg('');
            let endpoint = process.env.REACT_APP_PHP_URL+'forgot-password';
            const formData = {email:email}
            try {
                const res = await axios.post(endpoint, formData);            
                setSuccessmsg(res.data.message);
                setEmail(''); 
                setLoading(false);
              } catch (error) {
                if (error.response && error.response.data.message.email) {
                  setEmailerr(error.response.data.message.email[0]); 
                }
                else{setEmailerr('Something went wrong!!');}
                setLoading(false);
              }
        }
    const resetPassword = async(event) =>{
            setLoading(true);
            event.preventDefault();
            setPassworderr2('');
            setSuccessmsg('');
            if(npass==='')
            {
                setPassworderr2('New Password should not be empty!!');
                setLoading(false);                
            }
            else if(rpass==='')
            {
                setPassworderr2('Re-enter Password should not be empty!!');
                setLoading(false);   
            }
            else if(npass!==rpass)
            {
                setPassworderr2('New Password and Re-enter Password should be same!!');
                setLoading(false);
            }
            else{
            let endpoint = process.env.REACT_APP_PHP_URL+'reset-password';
            const formData = {email:getemail,password_confirmation:npass,password:rpass,token:id}
            try {
                const res = await axios(endpoint, {
                    method: "POST",
                    data:formData,
                    withCredentials: true,
                    headers: {
                      'Authorization': `Bearer ${id}`,
                      'Content-Type': 'application/json',
                    },
                  });         

                setSuccessmsg(res.data.message);
                navigate('/');
                setNpass('');
                setRpass('');
                setLoading(false);
              } catch (error) {                
                setLoading(false);
                if(error.response.data.message!==undefined)
                {
                    if(error.response.data.message.email!==undefined)
                    {
                        setPassworderr2(error.response.data.message.email[0]);
                    }
                    else
                    if(error.response.data.message.password!==undefined)
                    {
                        setPassworderr2(error.response.data.message.password[0]);
                    }
                    else
                    {
                        setPassworderr2(error.response.data.message);
                    }
                }
                else
                {
                setPassworderr2(error.response.data.error);
                }
              }
            }

        }
if(id!='' && id!=null)
{
return( <div className="container">
    {loading && <div>{loader}</div>}
    {!loading && (
    <div className="row">
        <div className="col-sm-3" >
        </div>
        <div className="col-sm-6" >
        <br/>
            <div className="card">
                <div className="card-body form" >
                <form>
                    <div className="mb-3">                  
                    <img src={logo} alt="" className="center"/>
                    <br/>
                    </div> 
                    <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input type="email" required className="form-control" aria-describedby="emailHelp" value={getemail} readOnly/>
                    </div>                                     
                    <div className="mb-3">
                    <label htmlFor="npass" className="form-label">New Password</label>
                    <input type="password" required className="form-control" id="npass" autoComplete="off" value={npass} onChange={(e) => setNpass(e.target.value)}/>
                    </div>
                    <div className="mb-3">
                    <label htmlFor="rpass" className="form-label">Re-enter Password</label>
                    <input type="password" required className="form-control" id="rpass" autoComplete="off" value={rpass} onChange={(e) => setRpass(e.target.value)}/>
                    <div className="invalid-feedback">{passworderr2}</div>
                    <div className="valid-feedback">{successmsg}</div>                       
                    </div>                 
                    <button type="submit" className="loginbtn btn btn-primary" onClick={resetPassword}>Reset Password</button>
                    <br/><br/>
                    <center><a href="/">Back to Login</a></center>
                    <br/>
                </form>
                </div>
            </div>		
        </div>
    </div>
    )}
    </div>);
    }
    else{

        return( <div className="container">
            {loading && <div>{loader}</div>}
            {!loading && (
            <div className="row">
                <div className="col-sm-3" >
                </div>
                <div className="col-sm-6" >
                <br/>
                    <div className="card">
                        <div className="card-body form" >
                        <form>
                            <div className="mb-3">                  
                            <img src={logo} alt="" className="center"/>
                            <br/>
                            </div>                
                            <div className="mb-3">
                            <label htmlFor="email" className="form-label">Email</label>
                            <input type="email" required className="form-control" id="email" aria-describedby="emailHelp" value={email} onChange={(e) => setEmail(e.target.value)}/>
                            <div className="invalid-feedback">{emailerr}</div>
                            <div className="valid-feedback">{successmsg}</div>   
                            </div>  
                            <button type="submit" className="loginbtn btn btn-primary" onClick={handleSubmit}>Reset Password</button>
                            <br/><br/>
                            <center><a href="/">Back to Login</a></center>
                            <br/>
                        </form>
                        </div>
                    </div>		
                </div>               
            </div>
             )}
            </div>);
    }
}
export default Forgotpassword;